<template>
  <DatatablePageLength v-model="pageLength" :options="limitOptions" />
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import Pagination from "@/lib/pagination";

import DatatablePageLength from "./DatatablePageLength.vue";

const props = withDefaults(
  defineProps<{
    pager?: Pagination;
    limitOptions?: number[];
    defaultLimit?: number;
  }>(),
  {
    limitOptions: () => [10, 25, 50, 100],
    defaultLimit: 25
  }
);
const pageLength = ref(props.defaultLimit.toString());

const emit = defineEmits(["update:data"]);
const limit = ref(props.defaultLimit || (props.limitOptions || [])[0]);

const limitOptions = computed(() => {
  return props.limitOptions.map((length) => ({
    label: length + " items",
    value: length.toString()
  }));
});

watch(pageLength, (val) => {
  handleLimitChange(val);
});

const handleLimitChange = async (value: string) => {
  if (!props.pager) return;
  const newLimit = parseInt(value, 10);
  if (newLimit === limit.value) return;
  limit.value = newLimit;
  const response = await props.pager.setLimit(value);
  if (response) {
    emit("update:data", response.data.data);
  }
};
</script>

<style scoped>
.per-page-select {
  width: 70px;
}
.pagination-buttons-cont {
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  border: 1px solid var(--secondary-color);
}
.pagination-button {
  border-right: 1px solid var(--secondary-color);
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  min-width: 40px;
  height: 35px;
  cursor: pointer;
  &:last-child {
    border-right: none;
  }
  &.selected {
    color: #fff;
    background: var(--tertiary-color);
  }
  &.disabled {
    background: var(--neutral-gray-400);
    opacity: 0.5;
  }
}
</style>
